<template>
  <Message
    :class="{
      'flex-row-reverse': message.sender_id === spark.state.user.id,
    }"
  >
    <QuickConversationUserAvatar
      v-if="message.sender_id === spark.state.user.id"
    />
    <QuickConversationSiaAvatar v-else />

    <MessageContent>
      <div v-if="message.is_typing">
        <MessageContentHint
          v-if="message.hint"
          class="tw:flex tw:items-start tw:gap-1"
        >
          <i class="tw:i-fal-screwdriver-wrench tw:size-4 tw:shrink-0 tw:mt-[2px]" />
          <span>{{ message.hint }}</span>
        </MessageContentHint>
        <div v-else-if="message.message">
          <p
            v-for="msg in message.message.split('\n')"
            class="tw:mb-0"
          >
            {{ msg }}
          </p>
        </div>
        <MessageContentLoading v-else />
      </div>
      <div v-else-if="!message.is_rich">
        <p
          v-for="msg in message.message.split('\n')"
          class="tw:mb-0"
        >
          {{ msg }}
        </p>
      </div>
      <div
        v-else
        class="tw:[&_a]:break-all"
      >
        <div v-html="convert_markdown(message.message)" />
        <div v-if="message.video_canonicals && message.video_canonicals.length > 0" class="tw:flex tw:flex-wrap tw:gap-2 tw:mt-2">
          <VideoPreviewCard
            v-for="canonical in message.video_canonicals"
            :key="canonical"
            :canonical="canonical"
          />
        </div>
      </div>
      <div
        v-if="message.sender_id !== spark.state.user.id && message.message"
        class="tw:flex tw:items-center tw:gap-2"
      >
        <MessageAudioButton :message="message.message" />
        <MessageCopyButton :message="message.message" />
      </div>
    </MessageContent>
  </Message>
</template>

<script setup>
import {
  Message,
  MessageAudioButton,
  MessageContent,
  MessageContentHint,
  MessageContentLoading,
  MessageCopyButton,
} from '@/components/common/message'
import VideoPreviewCard from '@/components/common/video-preview-card.vue'
import { convert_markdown } from '@/utils.js'
import QuickConversationSiaAvatar from './quick-conversation-sia-avatar.vue'
import QuickConversationUserAvatar from './quick-conversation-user-avatar.vue'

defineProps({
  message: {
    required: true,
  },
})
</script>
